/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DocumentService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Saves documents of group type invoice approval or financial statements to myremedi
     * Sample Call  http://URL/api/Document/UploadDocument?filename%3Dinvoice%20approval.xlsx%26docDateTime%3D2022-11-30T10%3A30%3A00%26orgUnit%3DABING_RSCVA1%0A
     * @param filename The file name of the file to be imported into myremedi stored documents
     * @param docDateTime Document date and time to assign to the stored document
     * @param orgUnit Single Organizational Unit to attach to the stored document
     * @param fileBytes Byte array of file contents from request body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public documentUploadDocument(filename: string, docDateTime: Date, orgUnit: string, fileBytes: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public documentUploadDocument(filename: string, docDateTime: Date, orgUnit: string, fileBytes: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public documentUploadDocument(filename: string, docDateTime: Date, orgUnit: string, fileBytes: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public documentUploadDocument(filename: string, docDateTime: Date, orgUnit: string, fileBytes: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (filename === null || filename === undefined) {
            throw new Error('Required parameter filename was null or undefined when calling documentUploadDocument.');
        }

        if (docDateTime === null || docDateTime === undefined) {
            throw new Error('Required parameter docDateTime was null or undefined when calling documentUploadDocument.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling documentUploadDocument.');
        }

        if (fileBytes === null || fileBytes === undefined) {
            throw new Error('Required parameter fileBytes was null or undefined when calling documentUploadDocument.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filename !== undefined && filename !== null) {
            queryParameters = queryParameters.set('filename', <any>filename);
        }
        if (docDateTime !== undefined && docDateTime !== null) {
            queryParameters = queryParameters.set('docDateTime', <any>docDateTime.toISOString());
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/Document/UploadDocument`,
            fileBytes,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
